import { Button, Form, Modal, notification, Radio, Upload } from "antd";
import { AcademicType } from "types/subscription";
import TextArea from "antd/lib/input/TextArea";
import { UploadOutlined } from "@ant-design/icons";
import React from "react";
import { useForm } from "antd/es/form/Form";
import { useKeycloak } from "services/keycloak/hook";
import { useRequestAcademic } from "services/rest/subscription";
import { baseUrl } from "services/rest/request";
import { useAccountInfo } from "services/account/hook";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { env } from "config";

export type AcademicModalProps = {
  visible: boolean,

  onAfterOk: () => void,
  onCancel: () => void,
}

export function AcademicModal(props: AcademicModalProps) {
  const { visible, onAfterOk, onCancel } = props;
  const intl = useIntl();
  const [form] = useForm();
  const keycloak = useKeycloak();
  const { loading, reload } = useAccountInfo();
  const navigate = useNavigate();
  const { loading: requestLoading, fetch } = useRequestAcademic();

  return (
    <Modal
      title={intl.formatMessage({ id: "jmix-store.academic-modal.title" })}
      open={visible}
      centered
      okButtonProps={{
        loading: loading || requestLoading
      }}
      onOk={() => {
        form.validateFields()
          .then(fields => {
            const data = {
              fileId: fields["attachment"]?.file.response.id,
              projectInfo: fields["description"],
              isStudent: fields["type"] === AcademicType.STUDENT,
            };

            fetch(data)
              .then(() => {
                reload()
                  .finally(() => {
                    onAfterOk();
                    navigate("/store/subscription/request-success");
                  });
              })
              .catch(() => {
                notification.error({
                  message: intl.formatMessage({ id: "jmix-store.error.academic-request.title" }),
                  description: intl.formatMessage({ id: "jmix-store.error.default.description" }, {
                    link: (str) => <a href={env.REACT_APP_JMIX_CONTACTS}>{str}</a>
                  }),
                  placement: "bottomLeft",
                });
              });
          });
      }}
      onCancel={onCancel}
    >
      <div className="academic-card__subtitle">
        {intl.formatMessage({ id: "jmix-store.academic-modal.description" })}
      </div>
      <Form
        layout="vertical"
        form={form}
      >
        <Form.Item
          label={intl.formatMessage({ id: "jmix-store.academic-modal.type-label" })}
          initialValue={AcademicType.STUDENT}
          name="type"
        >
          <Radio.Group>
            <Radio.Button value={AcademicType.STUDENT}>{intl.formatMessage({ id: "jmix-store.academic-modal.student" })}</Radio.Button>
            <Radio.Button value={AcademicType.STAFF}>{intl.formatMessage({ id: "jmix-store.academic-modal.staff" })}</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({ id: "jmix-store.academic-modal.project-info-label" })}
          name="description"
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "jmix-store.academic-modal.project-info.rule-message" }),
            }]
          }
        >
          <TextArea />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({ id: "jmix-store.academic-modal.file-label" })}
          name="attachment"
          valuePropName="file"
          required
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "jmix-store.academic-modal.file.rule-message" }),
            }
          ]}
        >
          <Upload
            maxCount={1}
            action={`${baseUrl}/files`}
            headers={{ "Authorization": `Bearer ${keycloak.token}` }}
          >
            <Button
              icon={<UploadOutlined />}
              type="primary"
              size="small"
              ghost
            >
              {intl.formatMessage({ id: "jmix-store.academic-modal.select-files-button" })}
            </Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
}